import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import * as adminApi from '../api/adminApi';
import './Login.css';

const ADMIN_TOKEN_KEY = 'adminToken';
const ADMIN_EMAIL_KEY = 'adminEmail';
const ADMIN_ROLE_KEY = 'adminRole';

const AdminLogin = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (!email || !password) {
      setError('Email and password are required');
      return;
    }
    setLoading(true);
    try {
      const data = await adminApi.adminLogin({ email, password });
      const token = data.token;
      const admin = data.admin || {};
      localStorage.setItem(ADMIN_TOKEN_KEY, token);
      if (admin.email) localStorage.setItem(ADMIN_EMAIL_KEY, admin.email);
      if (admin.role) localStorage.setItem(ADMIN_ROLE_KEY, admin.role);
      navigate('/power-user', { replace: true });
    } catch (err) {
      setError(err.message || 'Login failed. Check your credentials.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <div className="login-logo-container">
          <img src={`${process.env.PUBLIC_URL || ''}/logo.png`} alt="SimplyInventory Logo" className="login-logo" onError={(e) => { e.target.style.display = 'none'; }} />
        </div>
        <h1>SimplyInventory</h1>
        <h2>Admin / Power User Login</h2>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Email</label>
            <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required />
          </div>
          <div className="form-group">
            <label>Password</label>
            <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required />
          </div>
          {error && <div className="error">{error}</div>}
          <button type="submit" className="btn btn-primary" disabled={loading}>{loading ? 'Signing in...' : 'Sign In'}</button>
        </form>
        <p style={{ marginTop: '16px', fontSize: '14px' }}>
          <Link to="/login" style={{ color: '#0d6efd' }}>Back to workspace finder</Link>
        </p>
      </div>
    </div>
  );
};

export default AdminLogin;
